import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { useLabels, usePrefs } from 'wsm-common-data';
import { MOBILE } from '../utils/widgetInfoDefaults';
import useReplaceAccountName from '../hooks/useReplaceAccountName';

const Awards = ({ dealerData, deviceType }) => {
	const labels = useLabels();
	const { replaceAccountName } = useReplaceAccountName();
	const { communityAwardImageUrl, customerAwardImageUrl, goldAwardImageUrl } =
		usePrefs();

	const award = useMemo(() => {
		const flags = dealerData?.dealerData?.flags || [];
		if (flags.includes('lpgold')) {
			return {
				image: goldAwardImageUrl,
				header: replaceAccountName(
					labels.get('LOVE_PROMISE_AWARD_GOLD_HEADER')
				),
				content: labels.getHTML(
					replaceAccountName(
						labels.get('LOVE_PROMISE_AWARD_GOLD_CONTENT')
					)
				)
			};
		}
		if (flags.includes('lpcust')) {
			return {
				image: customerAwardImageUrl,
				header: replaceAccountName(
					labels.get('LOVE_PROMISE_AWARD_CUSTOMER_HEADER')
				),
				content: labels.getHTML(
					replaceAccountName(
						labels.get('LOVE_PROMISE_AWARD_CUSTOMER_CONTENT')
					)
				)
			};
		}
		if (flags.includes('lpcomm')) {
			return {
				image: communityAwardImageUrl,
				header: replaceAccountName(
					labels.get('LOVE_PROMISE_AWARD_COMMUNITY_HEADER')
				),
				content: labels.getHTML(
					replaceAccountName(
						labels.get('LOVE_PROMISE_AWARD_COMMUNITY_CONTENT')
					)
				)
			};
		}
		return null;
	}, [
		dealerData,
		goldAwardImageUrl,
		customerAwardImageUrl,
		communityAwardImageUrl,
		replaceAccountName,
		labels
	]);

	// If no award flag was found, don't render component
	if (award === null) return null;

	return (
		<div className="lp-awards row">
			<div className="col-sm-8 col-xs-12 mt-6">
				<h3
					className={`h3 text-center text-sm-left font-weight-normal ${
						deviceType !== MOBILE ? 'ddc-font-size-xxlarge' : ''
					}`}
				>
					{award.header}
				</h3>
				<img
					className="visible-xs mx-auto mb-4"
					src={award.image}
					alt={award.header}
				/>
				{award.content}
			</div>
			<div className="hidden-xs col-sm-4 mt-7 mb-4">
				<img className="mx-auto" src={award.image} alt={award.header} />
			</div>
		</div>
	);
};

export default Awards;

const AwardsProps = {
	deviceType: propTypes.string.isRequired,
	dealerData: propTypes.shape({
		dealerData: propTypes.shape({
			flags: propTypes.arrayOf(propTypes.string)
		})
	}).isRequired
};

Awards.propTypes = AwardsProps;
